import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
// import App from './App';
import * as serviceWorker from './serviceWorker';
import { Route, HashRouter } from 'react-router-dom';
import CoronaChatBot from './component/coronaChatBot';
import workRiskChatBot from './component/workRiskChatBot';
import ResultPage from './component/resultPage';
import WorkFitScanResultPage from './component/WorkFitScanResultPage';
import loadingResults from './component/loadingResults';
import telemer from './component/telemerBot';
import shortHDFC from './component/shortHDFC';
ReactDOM.render(
  <HashRouter>
    <Route exact path='/' component={CoronaChatBot}/>
    <Route exact path='/work-risk-bot' component={workRiskChatBot}/>
    <Route exact path='/result' component={ResultPage}/>
    <Route exact path='/result-work-fit' component={WorkFitScanResultPage}/>
    <Route exact path='/loading-results' component={loadingResults}/>
    <Route exact path='/telemer' component={telemer}/>
    <Route exact path='/hdfcdemo' component={shortHDFC}/>
  </HashRouter>
  , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
